<template>
  <div id="app">
    <router-view></router-view>
    <vue-progress-bar></vue-progress-bar>
  </div>
</template>

<script>
const getQueryString = name => {
  let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
  let r = window.location.search.substr(1).match(reg)
  if (r != null) return unescape(decodeURI(r[2]))
  return null
}

export default {
  name: 'app',
  created() {
    if (getQueryString('from') === 'demo') {
      sessionStorage.setItem('demo', '1')
    }
  }
}
</script>

<style lang="scss">
  $fa-font-path: '~font-awesome/fonts/';
  @import '~font-awesome/css/font-awesome.min.css';
  $simple-line-font-path: '~simple-line-icons/fonts/';
  @import '~simple-line-icons/css/simple-line-icons.css';
  @import '~material-design-iconic-font/dist/css/material-design-iconic-font.min.css';
</style>
<style lang="scss">
  @import './scss/style';
</style>



// WEBPACK FOOTER //
// src/app.vue